import React from "react";
import styles from "./EmissionLabel.module.scss";

type TDGEmissionProps = {
    value: string;
    valueLabel?: string;
    batteryValue?: string;
    batteryValueLabel?: string;
};

const TDGEmission: React.FC<TDGEmissionProps> = ({
    value,
    valueLabel = "",
    batteryValue = "",
    batteryValueLabel = "",
}) => {
    const emissionLabels = ["a", "b", "c", "d", "e", "f", "g"];

    const hasBatteryValue = batteryValue !== "";
    const styling: React.CSSProperties = {};
    if (hasBatteryValue) {
        styling["--or-_emission-columns"] = "2";
    }

    return (
        <div className={styles.emission} style={styling}>
            <div className={styles["emission-value-col"]} data-part="emission-value-col">
                {valueLabel}
            </div>
            {hasBatteryValue && (
                <div className={styles["emission-value-col"]} data-part="emission-value-col">
                    {batteryValueLabel}
                </div>
            )}
            <div>
                {emissionLabels.map((label) => (
                    <div
                        key={label}
                        className={`${styles["emission-label"]} ${styles[`label-${label.toLowerCase()}`]}`}
                    >
                        {label.toLowerCase()}
                    </div>
                ))}
            </div>
            <div className={styles["emission-value-col"]}>
                <div
                    className={`${styles["emission-value"]} ${styles[`emission-value-${value.toLowerCase().trim()}`]}`}
                >
                    {value.toLowerCase()}
                </div>
            </div>
            {hasBatteryValue && (
                <div className={`${styles["emission-value-col"]} ${styles["emission-value-col-2"]}`}>
                    <div
                        className={`${styles["emission-value"]} ${
                            styles[`emission-value-${batteryValue.toLowerCase().trim()}`]
                        }`}
                    >
                        {batteryValue.toLowerCase()}
                    </div>
                </div>
            )}
        </div>
    );
};
/**
 * WARNING: Always lazy load this component. No direct references
 */
export default TDGEmission;
